function openLink(url) {
  let a = document.createElement('a');
  a.setAttribute('href', url);
  a.setAttribute('target', '_blank');
  a.setAttribute('id', 'mediaShareLink');

  let ele_a = document.getElementById('mediaShareLink');
  if (ele_a) {
    document.body.removeChild(ele_a);
  }
  document.body.appendChild(a);
  a.click();
}

export function initMediaShareEvent(bus) {
  bus.$on('rocket:share:facebook', (URL) => {
    let url = URL || location.href;
    let share_link = `https://www.facebook.com/sharer/sharer.php?u=${url}&display=popup`;
    openLink(share_link);
  });
  bus.$on('rocket:share:line', (URL) => {
    let url = URL || location.href;
    let share_link = `https://social-plugins.line.me/lineit/share?url=${url}`;
    openLink(share_link);
  });
  bus.$on('rocket:share:whatsapp', (VALUE) => {
    let share_link = `https://api.whatsapp.com/send?text=${VALUE}`;
    openLink(share_link);
  });
}
